import { ReactNode } from "react";
import Link from 'next/link';
import { shouldPrefetch } from '@/lib/helpers/should-prefetch';
import AddIcon from '/public/svg/add.svg';
import PlayIcon from '/public/svg/play.svg';
import CheckIcon from '/public/svg/check.svg';
import DownIcon from '/public/svg/down.svg';
import ShuffleIcon from '/public/svg/shuffle.svg';
import styles from './Button.module.scss';
export interface LinkButtonProps {
  children: ReactNode;
  className?: string;
  disabled?: boolean;
  gtmLabel?: string;
  href: string | {
    pathname: string;
    query: {
      [key: string]: string;
    };
  };
  iconBefore?: "play" | "add" | "check";
  iconAfter?: "down" | "shuffle";
  onClick?: () => void;
  style?: "white_ghost" | "blue_ghost" | "white" | "blue" | "light_blue" | "yellow" | "red";
  target?: "_blank";
  title?: string;
  size?: 'responsive' | 'min' | 'max';
  wrapperComponent?: 'a' | 'Link';
}
const LinkButton = (props: LinkButtonProps) => {
  const {
    children,
    className,
    disabled = false,
    gtmLabel,
    href,
    onClick,
    style = "white_ghost",
    target,
    title,
    iconBefore,
    iconAfter,
    size = 'responsive',
    wrapperComponent = 'Link'
  } = props;
  let IconBefore = null;
  switch (iconBefore) {
    case 'play':
      IconBefore = <PlayIcon />;
      break;
    case 'add':
      IconBefore = <AddIcon />;
      break;
    case 'check':
      IconBefore = <CheckIcon />;
      break;
  }
  let IconAfter = null;
  switch (iconAfter) {
    case 'down':
      IconAfter = <DownIcon />;
      break;
    case 'shuffle':
      IconAfter = <ShuffleIcon />;
      break;
  }
  let classNames = `${styles[style]}`;
  if (className) {
    classNames += ` ${className}`;
  }
  if (size !== 'responsive') {
    classNames += ` ${styles[size]}`;
  }
  if (disabled) {
    classNames += ` ${styles.link_button_content_disabled}`;
  }
  const Element = wrapperComponent === 'a' ? 'a' : Link;
  return <Element href={href.toString()} className={classNames} target={target}
  // prefetch is a Link only prop
  prefetch={wrapperComponent === 'a' ? undefined : shouldPrefetch(href)} title={title} data-gtm-label={gtmLabel} rel={target === "_blank" ? "noopener noreferrer" : undefined} onClick={onClick} aria-disabled={disabled ? true : undefined} data-sentry-element="Element" data-sentry-component="LinkButton" data-sentry-source-file="LinkButton.tsx">
      {IconBefore}
      {children}
      {IconAfter}
    </Element>;
};
export default LinkButton;